import * as yup from 'yup';

const identityFields = {
  name: yup.string().required('Name is required'),
  externalId: yup
    .string()
    .required('External ID is required')
    .matches(/^\S+$/, 'External ID cannot contain spaces')
};

export const bundleSchema = yup.object().shape({
  ...identityFields,
  backgroundImage: yup.string().required('Background image is required'),
  backgroundColor: yup.mixed(),
  buttonSuffixImage: yup.string(),
  buttonSuffixAnimation: yup.string()
});

export const promotionSchema = yup.object().shape({
  ...identityFields,
  backgroundImage: yup.string().required('Background image is required'),
  backgroundColor: yup.mixed(),
  buttonSuffixImage: yup.string(),
  buttonSuffixAnimation: yup.string(),
  collectText: yup
    .string()
    .required('Free Offer Default Text is required')
    .max(25, 'Free Offer Default Text cannot exceed the maximum characters'),
  title: yup.string(),
  subTitleText: yup
    .string()
    .test('max-lines', 'Maximum of two lines allowed', (value) => {
      if (!value) return true;
      return (value.match(/\n/g) || []).length <= 1;
    }),
  fontSize: yup.number(),
  fontWeight: yup.string(),
  fontColor: yup.mixed()
});

export const progressBarSchema = yup.object().shape({
  ...identityFields,
  backgroundOpacity: yup.number().min(0).max(100).required('Background Opacity is required'),
  frameRadius: yup.number().min(0).required('Frame Radius is required'),
  barFillColor: yup.mixed(),
  barBackgroundColor: yup.mixed(),
  barRadius: yup.number().min(0),
  borderColor: yup.mixed(),
  borderWidth: yup.number().min(0),
  accumulatedItemImageUrl: yup.string().required('Accumulated Image is required'),
  accumulatedItemBackgroundImageUrl: yup.string().required('Accumulated Background Image is required'),
  textColor: yup.string(),
  barBackgroundImage: yup.string(),
  headerImage: yup.string()
});

export const popupSchema = yup.object().shape({
  ...identityFields,
  backgroundImage: yup.string().required('Background image is required'),
  backgroundColor: yup.mixed(),
  badgeCoverImage: yup.string(),
  borderColor: yup.mixed(),
  borderWidth: yup.number().min(0),
  title: yup.string(),
  fontSize: yup.number(),
  fontWeight: yup.string(),
  fontColor: yup.mixed()
});

export const rollingOfferSchema = yup.object().shape({
  ...identityFields,
  collectText: yup.string().required('Free Offer Text is required'),
  backgroundImage: yup.string(),
  horizontalBackgroundImage: yup.string(),
  backgroundColor: yup.mixed(),
  backgroundOpacity: yup.number().min(0).max(100).required('Background opacity is required'),
  borderColor: yup.mixed(),
  borderWidth: yup.number().min(0).max(8, 'Border width cannot exceed 8px').required('Offer border width is required'),
  arrowColor: yup.string(),
  arrowImage: yup.string(),
  headerImage: yup.string(),
  scrollArrowImage: yup.string(),
  offersBackgroundColor: yup.mixed(),
  offersBackgroundImage: yup.string(),
  enableScroll: yup.boolean()
});
